var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('forms-tab',{attrs:{"title":'Completed Company Forms for '+ _vm.$store.employee.first_name + ' ' + _vm.$store.employee.last_name,"employee-id":_vm.$store.employee.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }